import React from "react";
import { TheSidebar, TheFooter, TheHeader } from "./index";
import { useDispatch, useSelector } from "react-redux";
import { LOGIN, SUCCESS } from "src/store/actions/actionTypes";
import { ToastContainer } from "react-toastify";
// Import css

const TheLayout = ({ history }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user.data.accessToken);

  if (!user) {
    if (localStorage.getItem("userData")) {
      const data = JSON.parse(localStorage.getItem("userData"));
      dispatch({ type: LOGIN[SUCCESS], data });
    } else {
      history.push("/login");
    }
  }

  return (
    <div className="c-app c-default-layout">
      <TheSidebar />
      <div className="c-wrapper">
        <TheHeader />
        <div className="c-body">{/* <TheContent /> */}</div>
        <TheFooter />
        <ToastContainer autoClose={5000} />
      </div>
    </div>
  );
};

export default TheLayout;
